export default function (count: number): string {
  let result = ''
  while (count--) {
    result += '123456789ABCDEFGHJKLMNPQRSTUVWXYZ'.substr(Math.ceil(Math.random()*32), 1)
  }
  return result
}
